import React, { Component } from 'react';
import '../../css/dzbn.css';

// const { NavLink } = window.ReactRouterDOM;
class IconNavBar extends Component {
    render(){
        return(
            <div className='forIcons'>
                <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path d="M32.07 2A30 30 0 1 1 2.13 32.06V32A30 30 0 0 1 32.07 2m0-2A32 32 0 1 0 64 32.07V32A32 32 0 0 0 32.07 0z" fill="#fff"/>
                        <text transform="translate(13.17 40.67)" fontSize="30" fontFamily="PTSans-Narrow,PT Sans Narrow" letterSpacing=".03em" fill="#fff">
                            Р<tspan x="14.43" y="0">у</tspan><tspan x="26.46" y="0">с</tspan>
                        </text>
                    </svg>
                </li>
                <li>
                    <svg id="icon-eye" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path id="circle" fill="#fff" d="M32.07 2A30 30 0 1 1 2.13 32.06V32A30 30 0 0 1 32.07 2m0-2A32 32 0 1 0 64 32.07V32A32 32 0 0 0 32.07 0z"/>
                        <g id="eye">
                            <path fill="#fff" d="M32.15 19.28a21.26 21.26 0 0 0-19.29 12.3.83.83 0 0 0 0 .7 21.27 21.27 0 0 0 38.57 0 .83.83 0 0 0 0-.7 21.26 21.26 0 0 0-19.28-12.3zm0 21.39a8.73 8.73 0 1 1 8.73-8.73 8.73 8.73 0 0 1-8.73 8.73z"/>
                            <circle fill="#fff" cx="32.15" cy="31.93" r="5.59"/>
                        </g>
                    </svg>
                </li>
                <li>
                    <svg id="icon-message" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">

                        <path id="circle" fill="#fff" d="M32.07 2A30 30 0 1 1 2.13 32.06V32A30 30 0 0 1 32.07 2m0-2A32 32 0 1 0 64 32.07V32A32 32 0 0 0 32.07 0z"/>
                        <g id="message">
                            <path fill="#fff" d="M51.26 44.12V20.08L37.9 32.1l13.36 12.02zM31.89 37.51l-3.81-3.43L14.72 46.1h34.33L35.7 34.08l-3.81 3.43zM49.05 18.1H14.72l17.17 15.45L49.05 18.1zM12.53 20.08v24.04L25.88 32.1 12.53 20.08z"/>
                        </g>
                    </svg>
                </li>
                <li>
                    <svg id="icon-phone" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">

                        <path fill="#fff"  id="circle" d="M38.32 5.5A30 30 0 1 1 8.38 35.56v-.06a30 30 0 0 1 29.94-30m0-2a32 32 0 1 0 31.93 32.07v-.07a32 32 0 0 0-31.93-32z" transform="translate(-6.25 -3.5)"/>
                        <g id="phone">
                            <path fill="#fff" d="M47.13 40.84a2.29 2.29 0 0 0-3.46 0c-.81.8-1.62 1.6-2.41 2.42a.48.48 0 0 1-.67.12c-.52-.29-1.08-.52-1.58-.83A25.1 25.1 0 0 1 33 37a14.33 14.33 0 0 1-2.17-3.47.5.5 0 0 1 .12-.64c.81-.78 1.6-1.58 2.39-2.39a2.3 2.3 0 0 0 0-3.54l-1.9-1.9c-.65-.65-1.3-1.31-2-2a2.3 2.3 0 0 0-3.46 0c-.82.8-1.6 1.62-2.43 2.41a3.94 3.94 0 0 0-1.24 2.66 11.26 11.26 0 0 0 .87 4.85 29.45 29.45 0 0 0 5.23 8.71 32.35 32.35 0 0 0 10.71 8.38 15.49 15.49 0 0 0 5.93 1.73 4.35 4.35 0 0 0 3.73-1.42c.69-.77 1.48-1.48 2.21-2.22a2.31 2.31 0 0 0 0-3.52zM45.83 35.42l2.51-.42a11.26 11.26 0 0 0-9.52-9.24l-.35 2.52a8.7 8.7 0 0 1 7.37 7.14z" transform="translate(-6.25 -3.5)"/>
                            <path fill="#fff" d="M49.75 24.51a18.5 18.5 0 0 0-10.6-5.29l-.35 2.52A16.14 16.14 0 0 1 52.45 35l2.55-.44a18.63 18.63 0 0 0-5.25-10.05z" transform="translate(-6.25 -3.5)"/>
                        </g>
                    </svg>
                </li>
                <li>
                    <svg id="icon-user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path fill="#fff" id="circle" d="M32.07 2A30 30 0 1 1 2.13 32.06V32A30 30 0 0 1 32.07 2m0-2A32 32 0 1 0 64 32.07V32A32 32 0 0 0 32.07 0z"/>
                        <g id="user">
                            <path fill="#fff" d="M32.17 31.26c3.63 0 6.56-3.57 6.56-8s-1-8-6.56-8-6.56 3.57-6.56 8 2.94 8 6.56 8zM44.56 44.13c-.12-7.67-1.12-9.86-8.79-11.24a4.6 4.6 0 0 1-3.59 1.38 4.6 4.6 0 0 1-3.59-1.38c-7.58 1.37-8.65 3.52-8.79 11v1.38S21.63 49 32.2 49s12.4-3.68 12.4-3.68v-.6a4.94 4.94 0 0 1-.04-.59z"/>
                        </g>
                    </svg>
                </li>
                <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path d="M32.07 2A30 30 0 1 1 2.13 32.06V32A30 30 0 0 1 32.07 2m0-2A32 32 0 1 0 64 32.07V32A32 32 0 0 0 32.07 0z" fill="#fff"/>
                        <g stroke="#fff">
                            <path d="M28.23 19.69a8.56 8.56 0 1 1-8.56 8.56 8.56 8.56 0 0 1 8.56-8.56m0-2.88a11.44 11.44 0 1 0 11.44 11.44 11.44 11.44 0 0 0-11.44-11.44z" strokeMiterlimit="10" strokeWidth=".5" fill="#fff"/>
                            <path data-name="Составной контур" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M36.23 36.06l10.94 10.95"/>
                        </g>
                    </svg>
                </li>
            </div>
        )
    }
}

export default IconNavBar



// WEBPACK FOOTER //
// ./assets/src/js/components/IconNavBar.jsx